<template>
  <div class="checkVideo">
    <div class="top-type">
      <span>商品展示视频内容的方式:</span>
      <el-radio-group v-model="videoTypeValue" @change="changeType()">
        <el-radio :label="0">非层级</el-radio>
        <el-radio :label="1">层级</el-radio>
      </el-radio-group>

      <!--<el-select v-model="videoTypeValue" placeholder="请选择" @change="changeType()">-->
      <!--<el-option-->
      <!--v-for="item in options"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="非层级类型新增" name="first">
        <el-card>
          <el-row>
            <el-col :span="4">
              <el-input placeholder="搜索视频名称" v-model="searchForm.name"></el-input>
            </el-col>
            <el-col :span="10" style="float: right">
              <el-button-group style="float: right">
                <el-button
                  type="primary"
                  @click="(page.pageNumber = 1), pageListLeft()"
                  icon="el-icon-search"
                  >查询</el-button
                >
                <el-button type="primary" @click="batchUnbund()">批量解绑</el-button>
                <el-button type="primary" @click="updateTryUse()">批量试看</el-button>
                <el-button
                  type="primary"
                  @click="goAddVideoInfo()"
                  icon="el-icon-plus"
                  style="float: right; margin-bottom: 20px"
                  >选择视频</el-button
                >
              </el-button-group>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 20px">
            <el-col>
              <el-button type="primary" @click="sortByName(1)">正序</el-button>
              <el-button type="primary" @click="sortByName(0)">倒序</el-button>
            </el-col>
          </el-row>
          <div v-loading="webLoading">
            <el-table
              ref="multipleTables"
              :data="page.rows"
              tooltip-effect="dark"
              v-if="name == '录播'"
              style="width: 100%"
              border
              @selection-change="selectionChangeLeft"
            >
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column
                prop="videoCourseName"
                label="具体课程"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="视频名称"
                :show-overflow-tooltip="true"
              ></el-table-column>

              <el-table-column
                prop="size"
                label="大小"
                :show-overflow-tooltip="true"
                width="100"
                align="center"
              >
                <template slot-scope="scope" v-if="scope.row.size != null"
                  >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template
                >
              </el-table-column>
              <el-table-column
                prop="size"
                label="绑定试题数量"
                :show-overflow-tooltip="true"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="bindQuestion(scope.row.id)"
                    >{{ scope.row.questionCount }}</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column prop="tryUse" label="试看" align="center" width="100">
                <template slot-scope="row">
                  <span v-if="row.row.tryUse == '1'" class="mainColor">是</span>
                  <span v-else class="mainColor">否</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="playCount" label="次数" align="center" width="100"></el-table-column> -->
              <el-table-column
                align="center"
                prop="url"
                label="播放"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <i
                    class="el-icon-caret-right"
                    style="font-size: 20px; color: #409eff"
                    @click="inintVideo(scope.row)"
                  ></i>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="duration" align="center" width="100" label="时长"></el-table-column> -->
              <el-table-column prop label="操作" width="160" align="center">
                <template slot-scope="scope">
                  <div class="operationGroup">
                    <el-popover
                      placement="bottom"
                      width="320"
                      :ref="'popover' + scope.row.id"
                    >
                      <div class="operationGroup-flex">
                        <div style="line-height: 30px">排列至第</div>
                        <el-input
                          size="samll"
                          v-model="scope.row.videoInfoCourseRelationSort"
                          type="number"
                          style="width: 100px; height: 30px; margin-left: 5px"
                        ></el-input>
                        <div style="line-height: 30px; margin-left: 5px">位</div>
                        <el-button
                          size="small"
                          style="height: 30px; margin-left: 10px"
                          @click="closePopover(scope.row.id)"
                          >取消</el-button
                        >
                        <el-button
                          type="primary"
                          style="height: 30px; margin-left: 10px"
                          size="small"
                          @click="updateVideoInfoCourseInfoSort(scope.row)"
                          >确定</el-button
                        >
                      </div>
                      <el-button slot="reference" type="text" size="small"
                        >排序</el-button
                      >
                    </el-popover>
                    <el-button type="text" size="small" @click="getVideoInfo(scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      type="text"
                      size="small"
                      @click="downloadFileVideo(scope.row.url, scope.row.name, scope)"
                      >下载</el-button
                    >
                    <el-button type="text" size="small" @click="deleteVideo(scope.row)"
                      >解绑</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            :key="page.total"
            background
            layout="total, sizes, prev, pager, next"
            style="margin-top: 20px; text-align: right"
            :total="page.total"
            :page-sizes="[10, 20, 30, 40]"
            :small="true"
            :page-size="page.pageSize"
            :current-page="page.pageNumber"
            @size-change="sizeChange"
            @current-change="currentChange"
          ></el-pagination>
          <div slot="footer" class="dialog-footer" style="text-align: right">
            <!-- <el-button type="primary" @click="addQuestionBatchVideo" icon="el-icon-document">保存</el-button> -->
          </div>
          <el-dialog
            title="预览视频"
            :visible.sync="videoDialog"
            @close="closeDialog"
            width="900px"
            :append-to-body="true"
            :close-on-click-modal="false"
          >
            <video
              v-if="videoShow"
              id="player-container-id"
              width="860"
              height="450"
              preload="auto"
              playsinline
              webkit-playsinline
            ></video>
          </el-dialog>
          <el-dialog
            :title="'添加' + name + '视频'"
            :append-to-body="true"
            :visible.sync="addFormVisible2"
            width="900px"
            :close-on-click-modal="false"
          >
            <el-form
              ref="addForm"
              :model="addForm2"
              :label-width="formLabelWidth"
              :rules="addFormRules"
            >
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频名称" prop="name">
                    <el-input
                      v-model="addForm2.name"
                      placeholder="请输入名称"
                      auto-complete="off"
                      maxlength="120"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="排序" prop="sort">
                    <el-input
                      type="number"
                      v-model="addForm2.sort"
                      placeholder="请输入排序"
                      auto-complete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="总开始时间" prop="startTime">
                    <el-date-picker
                      style="width: 100%"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="addForm2.startTime"
                      type="datetime"
                      placeholder="选择日期时间"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="预计时长" prop="value">
                    <el-select
                      :disabled="addForm2.startTime ? false : true"
                      style="width: 100%"
                      v-model="addForm2.value"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in 24"
                        :key="item"
                        :label="item + '小时'"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="18" :md="12" :lg="12">
                  <el-form-item label="试看" prop="tryUse">
                    <!-- <el-input v-model="addForm2.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
                    <el-radio-group v-model="addForm2.tryUse" size="small">
                      <el-radio label="1">是</el-radio>
                      <el-radio label="-1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :sm="24" :md="24" :lg="24">
                  <el-form-item label="视频说明" prop="remark">
                    <el-input
                      type="textarea"
                      v-model="addForm2.remark"
                      placeholder="请输入视频说明"
                      auto-complete="off"
                      maxlength="300"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: right">
              <el-button @click="addFormVisible2 = false">取 消</el-button>
              <el-button type="primary" @click="addVideoInfo">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog
            :title="'添加' + name + '视频'"
            :append-to-body="true"
            :visible.sync="addFormVisible"
            width="900px"
            :close-on-click-modal="false"
          >
            <el-form
              ref="addForm"
              :model="addForm"
              :label-width="formLabelWidth"
              :rules="addFormRules"
            >
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频名称" prop="name">
                    <el-input
                      v-model="addForm.name"
                      placeholder="请输入名称"
                      auto-complete="off"
                      maxlength="120"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频地址" prop="url">
                    <el-input
                      v-model="addForm.url"
                      placeholder="请输入视频地址"
                      auto-complete="off"
                      maxlength="500"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="排序" prop="sort">
                    <el-input
                      type="number"
                      v-model="addForm.sort"
                      placeholder="请输入排序"
                      auto-complete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="18" :md="12" :lg="12">
                  <el-form-item label="试看" prop="tryUse">
                    <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
                    <el-radio-group v-model="addForm.tryUse" size="small">
                      <el-radio label="1">是</el-radio>
                      <el-radio label="-1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频id" prop="tencentVideoId">
                    <el-input
                      v-model="addForm.tencentVideoId"
                      placeholder="请输入腾讯视频id"
                      auto-complete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="腾讯appid" prop="tencentAppid">
                    <el-input
                      v-model="addForm.tencentAppid"
                      placeholder="请输入腾讯appid"
                      auto-complete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="播放次数" prop="playCount">
                    <el-input
                      v-model="addForm.playCount"
                      placeholder="请输入播放次数"
                      auto-complete="off"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="播放时长" prop="duration">
                    <el-input
                      v-model="addForm.duration"
                      placeholder="请输入播放时长"
                      auto-complete="off"
                      maxlength="11"
                    >
                      <template slot="append">秒</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row></el-row>
              <el-row>
                <el-col :sm="24" :md="24" :lg="24">
                  <el-form-item label="视频说明" prop="remark">
                    <el-input
                      type="textarea"
                      v-model="addForm.remark"
                      placeholder="请输入视频说明"
                      auto-complete="off"
                      maxlength="300"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: right">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="addVideoInfo">确 定</el-button>
            </div>
          </el-dialog>

          <el-dialog
            title="编辑直播视频"
            :append-to-body="true"
            :visible.sync="editFormVisible2"
            width="900px"
            left
            :close-on-click-modal="false"
          >
            <el-form
              ref="editForm"
              :model="editForm2"
              :label-width="formLabelWidth"
              :rules="editFormRules"
            >
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频名称" prop="name">
                    <el-input
                      v-model="editForm2.name"
                      placeholder="请输入名称"
                      auto-complete="off"
                      maxlength="120"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="排序" prop="sort">
                    <el-input
                      type="number"
                      v-model="editForm2.sort"
                      placeholder="请输入排序"
                      auto-complete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="总开始时间" prop="startTime">
                    <el-date-picker
                      style="width: 100%"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="editForm2.startTime"
                      type="datetime"
                      placeholder="选择日期时间"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="预计时长" prop="value">
                    <el-select
                      :disabled="editForm2.startTime ? false : true"
                      style="width: 100%"
                      v-model="editForm2.value"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in 24"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="18" :md="12" :lg="12">
                  <el-form-item label="试看" prop="tryUse">
                    <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
                    <el-radio-group v-model="editForm2.tryUse" size="small">
                      <el-radio label="1">是</el-radio>
                      <el-radio label="-1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="24" :lg="24">
                  <el-form-item label="视频说明" prop="remark">
                    <el-input
                      type="textarea"
                      v-model="editForm2.remark"
                      placeholder="请输入视频说明"
                      auto-complete="off"
                      maxlength="300"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div
              slot="footer"
              class="dialog-footer"
              style="text-align: right"
              :close-on-click-modal="false"
            >
              <el-button @click="editFormVisible2 = false">取 消</el-button>
              <el-button type="primary" @click="updateVideoInfo">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog
            title="编辑录播视频"
            :append-to-body="true"
            :visible.sync="editFormVisible"
            width="900px"
            left
            :close-on-click-modal="false"
          >
            <el-form
              ref="editForm"
              :model="editForm"
              :label-width="formLabelWidth"
              :rules="editFormRules"
            >
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频名称" prop="name">
                    <el-input
                      v-model="editForm.name"
                      placeholder="请输入名称"
                      auto-complete="off"
                      maxlength="120"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频地址" prop="url">
                    <el-input
                      v-model="editForm.url"
                      placeholder="请输入视频地址"
                      auto-complete="off"
                      maxlength="500"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="排序" prop="sort">
                    <el-input
                      type="number"
                      v-model="editForm.sort"
                      placeholder="请输入排序"
                      auto-complete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="18" :md="12" :lg="12">
                  <el-form-item label="试看" prop="tryUse">
                    <!-- <el-input v-model="addForm.type" placeholder="请输入类别：免费/付费/会员" auto-complete="off" maxlength="50"></el-input> -->
                    <el-radio-group v-model="editForm.tryUse" size="small">
                      <el-radio label="1">是</el-radio>
                      <el-radio label="-1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="视频id" prop="tencentVideoId">
                    <el-input
                      v-model="editForm.tencentVideoId"
                      placeholder="请输入腾讯视频id"
                      auto-complete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="24" :md="12" :lg="12">
                  <el-form-item label="播放次数" prop="playCount">
                    <el-input
                      v-model="editForm.playCount"
                      placeholder="请输入播放次数"
                      auto-complete="off"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :sm="24" :md="24" :lg="24">
                  <el-form-item label="视频说明" prop="remark">
                    <el-input
                      type="textarea"
                      v-model="addForm.remark"
                      placeholder="请输入视频说明"
                      auto-complete="off"
                      maxlength="300"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div
              slot="footer"
              class="dialog-footer"
              style="text-align: right"
              :close-on-click-modal="false"
            >
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="updateVideoInfo">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog
            title="excel导入"
            :append-to-body="true"
            :visible.sync="addFormVisibleExcel"
            width="900px"
            :close-on-click-modal="false"
          >
            <div class="flex-view">
              <el-upload
                class="upload-demo"
                :action="fileAction"
                :on-success="handleSuccess"
                :headers="reqData"
                :show-file-list="false"
              >
                <el-button size="small" type="primary" icon="el-icon-upload"
                  >点击上传</el-button
                >
              </el-upload>
              <el-button
                style="margin-left: 10px"
                size="small"
                type="primary"
                @click="downloadFile()"
                >下载模板</el-button
              >
              <div style="margin-left: 10px" class="el-upload__tip">
                只能上传xls、xlsx文件，且不超过1024kb
              </div>
            </div>
            <el-table
              ref="multipleTables"
              :data="importForm"
              tooltip-effect="dark"
              style="width: 100%"
              border
              @selection-change="selectionExcel"
            >
              <!-- <el-table-column type="selection" width="40"></el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                prop="name"
                label="视频名称"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="tencentVideoId"
                label="视频id"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="url"
                label="视频地址"
              ></el-table-column>

              <el-table-column
                show-overflow-tooltip
                prop="duration"
                label="视频时长"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="playCount"
                label="播放次数"
              ></el-table-column>
              <el-table-column show-overflow-tooltip prop="tryUse" label="是否试看">
                <template slot-scope="row">
                  <span v-if="row.row.tryUse == '1'" class="mainColor">是</span>
                  <span v-else class="mainColor">否</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="tencentAppid"
                label="腾讯appid"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="remark"
                label="视频说明"
              ></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer" style="text-align: right">
              <el-button @click="addFormVisibleExcel = false">取 消</el-button>
              <el-button type="primary" @click="bindExcel()">确 定</el-button>
            </div>
          </el-dialog>
          <el-dialog
            title="同步腾迅云"
            :append-to-body="true"
            :visible.sync="tencentSyncVisible"
            width="900px"
            :loading="openTencentLoading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255, 255, 255, 0.8)"
            :close-on-click-modal="false"
          >
            <div>
              <el-row :gutter="20">
                <el-col :span="4">
                  <el-button
                    size="small"
                    type="primary"
                    @click="syncTencent()"
                    :loading="this.syncStatus"
                    >同步腾迅云</el-button
                  >
                </el-col>
                <el-col :span="20" style="text-align: right">
                  <el-input
                    style="width: 200px"
                    size="small"
                    v-model="tencentPage.name"
                    placeholder="请输入视频名称"
                    clearable
                  ></el-input>
                  <el-input
                    style="width: 200px"
                    size="small"
                    v-model="tencentPage.remark"
                    placeholder="请输入备注关键字"
                    clearable
                  ></el-input>
                  <el-button
                    size="small"
                    type="primary"
                    @click="(tencentPage.pageNumber = 1), openTencent()"
                    >查询</el-button
                  >
                </el-col>
              </el-row>
            </div>
            <el-table
              ref="multipleTables"
              :data="tencentPage.rows"
              @selection-change="selectionChangeTencent"
              tooltip-effect="dark"
              style="width: 100%; margin-top: 10px"
              border
            >
              <el-table-column
                :show-overflow-tooltip="true"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="name"
                label="视频名称"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="tencentVideoId"
                label="视频id"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="url"
                label="视频地址"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="duration"
                label="视频时长"
              ></el-table-column>
              <el-table-column prop="createTime" label="上传时间"></el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, sizes, prev, pager, next"
              style="margin-top: 20px; text-align: right"
              :total="tencentPage.total"
              :page-sizes="[10, 20, 30, 40]"
              :small="true"
              :page-size="tencentPage.pageSize"
              :current-page="tencentPage.pageNumber"
              @size-change="sizeChangeTencent"
              @current-change="currentChangeTencent"
            ></el-pagination>
            <div slot="footer" class="dialog-footer" style="text-align: right">
              <el-button @click="tencentSyncVisible = false">取 消</el-button>
              <el-button type="primary" @click="bindTencent()">确 定</el-button>
            </div>
          </el-dialog>
          <!--绑定试题弹框-->
          <el-dialog title="绑定试题" :visible.sync="bindQuestionVisible" width="45%">
            <el-row class="mb15">
              <el-col>
                <el-button
                  type="primary"
                  @click="
                    innerVisible = true;
                    pageList();
                  "
                  >添加试题</el-button
                >
              </el-col>
            </el-row>
            <el-dialog
              width="50%"
              title="添加绑定试题"
              v-loading="webLoading"
              :visible.sync="innerVisible"
              custom-class="question"
              append-to-body
            >
              <el-table
                ref="multipleTable"
                :data="questionPage.rows"
                row-key="id"
                border
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="selectionChange"
              >
                <el-table-column type="selection" width="40"></el-table-column>

                <el-table-column
                  prop="big"
                  label="类型"
                  width="100"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.big == 1">大题</span>
                    <span v-else-if="scope.row.big == -1 && scope.row.pid.length == 1"
                      >常规试题</span
                    >
                    <span v-else>小题</span>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="courseName"
                  label="课程"
                  width="160"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="title" show-overflow-tooltip label="题干">
                  <template slot-scope="scope">
                    <div class="message">
                      <div class="state">
                        <span
                          v-if="scope.row.state == 1"
                          style="background: rgb(24, 200, 168)"
                          >上架</span
                        >
                        <span v-else style="background: rgba(231, 76, 60, 1)">下架</span>
                      </div>
                      <div class="questionTypeName" v-if="scope.row.big != 1">
                        <span style="background: #409eff">{{
                          scope.row.questionTypeName
                        }}</span>
                      </div>
                      <div
                        class="htmltittle"
                        @click="getInfoById(scope.row.id)"
                        v-html="scope.row.title"
                      ></div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="answer"
                  label="答案"
                  align="center"
                  width="60"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.big != 1">{{ scope.row.answer || "-" }}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-if="!webLoading"
                background
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                style="margin-top: 20px; text-align: right"
                :total="questionPage.total"
                :page-size="questionPage.pageSize"
                :current-page="questionPage.pageNumber"
                @size-change="innerSizeChange"
                @current-change="innerCurrentChange"
              ></el-pagination>
              <span slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="innerQuestionSure">确 定</el-button>
              </span>
            </el-dialog>

            <el-table border :data="bindedQuestionPage.rows">
              <el-table-column label="类型" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.big == 1">大题</span>
                  <span v-else-if="scope.row.big == -1 && scope.row.pid.length == 1"
                    >常规试题</span
                  >
                  <span v-else>小题</span>
                </template>
              </el-table-column>

              <el-table-column prop="courseName" label="课程"> </el-table-column>
              <el-table-column show-overflow-tooltip label="题干" width="350">
                <template slot-scope="scope">
                  <div class="message">
                    <div class="state">
                      <span
                        v-if="scope.row.state == 1"
                        style="background: rgb(24, 200, 168)"
                        >上架</span
                      >
                      <span v-else style="background: rgba(231, 76, 60, 1)">下架</span>
                    </div>
                    <div class="questionTypeName" v-if="scope.row.big != 1">
                      <span style="background: #409eff">{{
                        scope.row.questionTypeName
                      }}</span>
                    </div>
                    <div
                      class="htmltittle"
                      @click="getInfoById(scope.row.id)"
                      v-html="scope.row.title"
                    ></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="deleteBindQuestion(scope.row.id)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
              <el-button @click="bindQuestionVisible = false">取 消</el-button>
              <el-button type="primary" @click="bindQuestionVisible = false"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="层级类型新增" name="second">
        <el-card>
          <el-row>
            <el-col :span="4">
              <el-input placeholder="搜索视频名称" v-model="searchForm.name"></el-input>
            </el-col>
            <el-col :span="10" style="float: right">
              <el-button-group style="float: right">
                <el-button
                  type="primary"
                  @click="dialogLevelVisible = true"
                  icon="el-icon-plus"
                  >添加分组</el-button
                >
              </el-button-group>
            </el-col>
          </el-row>

          <!--table-->
          <el-table
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @expand-change="expandSelect"
            :data="tableData"
            style="width: 100%; margin-bottom: 20px; margin-top: 20px"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-button type="primary" @click="sortByName(1, props.$index)"
                  >正序</el-button
                >
                <el-button type="primary" @click="sortByName(0, props.$index)"
                  >倒序</el-button
                >
                <el-table
                  :data="props.row.videoInfoList"
                  style="width: 100%; margin-bottom: 20px; margin-top: 20px"
                  :row-key="id"
                  border
                  default-expand-all
                  :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                >
                  <el-table-column type="index" width="50" label="序号" align="center">
                  </el-table-column>
                  <el-table-column prop="videoCourseName" label="具体课程">
                  </el-table-column>
                  <el-table-column prop="name" label="视频名称"> </el-table-column>
                  <el-table-column label="大小">
                    <template slot-scope="scope" v-if="scope.row.size != null"
                      >{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template
                    >
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-popconfirm
                        confirm-button-text="确定"
                        cancel-button-text="取消"
                        icon="el-icon-info"
                        icon-color="red"
                        title="确定解绑吗？"
                        @confirm="
                          delSubjectVideoRelation(scope.row.subjectVideoRelationId)
                        "
                      >
                        <el-button type="text" slot="reference">解绑</el-button>
                      </el-popconfirm>
                      <el-button
                        type="text"
                        slot="reference"
                        @click="editBySort(scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        type="text"
                        slot="reference"
                        @click="inintVideo(scope.row)"
                        >播放</el-button
                      >
                      <!-- <i class="el-icon-caret-right" style="font-size: 20px; color: #409eff" @click="inintVideo(scope.row)"></i> -->
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="分组名称" prop="name"> </el-table-column>

            <el-table-column label="描述" prop="desc"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <!--<span @click="batchUnbund()" style="margin-right: 30px"-->
                <!--class="mainColor">批量解绑</span>-->
                <!--<span @click="updateTryUse()" style="margin-right: 30px"-->
                <!--class="mainColor">批量试看</span>-->
                <span
                  @click="groupDelete(scope.row.id)"
                  style="margin-right: 30px"
                  class="mainColor"
                  >删除分组</span
                >
                <span
                  @click="addGoodsVideo(scope.row.id, scope.$index)"
                  style="margin-right: 30px"
                  class="mainColor"
                  icon="el-icon-plus"
                  >选择视频</span
                >
                <span
                  @click="editBtn(scope.row)"
                  style="margin-right: 30px"
                  class="mainColor"
                  icon="el-icon-plus"
                  >编辑</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!--table2-->
          <el-table
            :data="levelTabel"
            style="width: 100%; margin-bottom: 20px; margin-top: 20px; display: none"
            row-key="id"
            border
            default-expand-all
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column prop="date" label="所属分组/课程" sortable width="180">
            </el-table-column>
            <el-table-column prop="name" label="名称" sortable> </el-table-column>
            <el-table-column prop="address" label="类型"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span style="margin-right: 30px" class="mainColor">添加</span>
                <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定解绑吗？"
                >
                  <el-button type="text" slot="reference">解绑</el-button>
                </el-popconfirm>
                <span style="margin-left: 30px" class="mainColor">查看</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="添加分组" :visible.sync="dialogLevelVisible">
      <el-form :model="form" ref="form">
        <el-form-item label="分组名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="form.sort"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogLevelVisible = false">取 消</el-button>
        <el-button type="primary" @click="levelSure()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="dialogSortVisible" width="30%">
      <el-form ref="form">
        <el-form-item label="视频名称" :label-width="formLabelWidth">
          <el-input v-model="sortForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="试看" prop="tryUse" :label-width="formLabelWidth">
          <el-checkbox v-model="sortForm.tryUse">开启片段试看</el-checkbox>
          <span
            >视频前<el-input
              size="small"
              :disabled="!sortForm.tryUse"
              style="width: 80px; margin: auto 5px"
              v-model="sortForm.tryDuration"
              type="number"
            ></el-input
            >分钟为试看范围</span
          >
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="sortForm.subjectVideoRelationSort"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSortVisible = false">取 消</el-button>
        <el-button type="primary" @click="sortComfireBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择视频" :visible.sync="selectVideoVisible" width="800px" left>
      <videoMaterial
        @videoListChange="changeVideoList"
        v-if="selectVideoVisibleBlock"
      ></videoMaterial>
    </el-dialog>
  </div>
</template>

<script>
import videoMaterial from "../common/videoMaterial";

import draggable from "vuedraggable";
import $ from "jquery";
export default {
  components: { draggable, videoMaterial },
  props: {
    id: {
      type: String,
    },
  },
  created() {},

  data() {
    return {
      sortForm: {},
      dialogSortVisible: false,
      subjectVideoIndex: 0,
      expands: [],
      subjectVideoPid: "",
      selectVideoVisible: false,
      selectVideoVisibleBlock: false,
      dialogLevelVisible: false,
      videoList: [],
      form: {
        name: "",
        sort: 0,
      },
      options: [
        {
          value: 1,
          label: "层级",
        },
        {
          value: 0,
          label: "非层级",
        },
      ],
      videoTypeValue: null,
      activeName: "first",
      levelTabel: [
        {
          id: 1,
          date: "test",
          name: "21年一级建造师水利水电工程纯金考点班",
          address: "录播",
        },

        {
          id: 3,
          date: "test",
          name: "",
          address: "录播",
          children: [
            {
              id: 31,
              date: "《公路》",
              name: "21年一级建造师水利水电工程纯金考点班",
              address: "录播",
            },
            {
              id: 32,
              date: "《公路》",
              name: "21年一级建造师水利水电工程纯金考点班",
              address: "录播",
            },
          ],
        },
      ],
      tableData: [
        //     {
        //         id: '12987122',
        // name: '好滋好味鸡蛋仔',
        // category: '江浙小吃、小吃零食',
        // desc: '荷兰优质淡奶，奶香浓而不腻',
        // address: '上海市普陀区真北路',
        // shop: '王小虎夫妻店',
        // shopId: '10333',
        // levelTabel: [{
        //     id: 1,
        //     date: 'test',
        //     name: '',
        //     address: '录播'
        // }]}
      ],
      videoInfoId: "",
      questionPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      bindedQuestionPage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        videoInfoId: "",
      },
      innerVisible: false,
      multipleSelection: "",
      ids: undefined,
      bindQuestionVisible: false,
      openTencentLoading: false,
      player: null,
      videoShow: false,
      loadVideoShow: false,
      syncStatus: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      name: this.$route.query.name,
      formLabelWidth: "100px",
      createTime: [],
      fileAction: `${process.env.BASE_URL}/videoInfo/importVideoInfoExcel`,

      priceDisabled: true,
      addFormVisibleExcel: false,
      tencentSyncVisible: false,
      priceEditDisabled: true,
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      tencentPage: {
        rows: [],
        total: 0,
        remark: "",
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      webLoading: false,
      videoDialog: false,
      addFormVisible2: false,
      addFormVisible: false,
      editFormVisible: false,
      editFormVisible2: false,
      videoCourseIds: [],
      addVideoLeft: [],
      addTencentVideo: [],
      addVideoRight: [],
      videoCourseTree: [],
      subjectTreeList: [], //科目
      subjectTreeProps: {
        multiple: true,
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreePropsNo: {
        value: "id",
        label: "name",
        children: "children",
      },
      addForm: {
        videoCourseId: "",
        name: "",
        courseId: "",
        sort: "",
        tryUse: "-1",
        price: "",
        tencentVideoId: "",
        tencentAppid: "",
        enabled: "1",
        url: "",
        remark: "",
        playCount: "",
        duration: "",
      },
      addForm2: {
        name: "",
        sort: "",
        tryUse: "-1",
        remark: "",
        startTime: "",
        endTime: "",
        enabled: "1",
      },
      addFormRules: {
        videoCourseId: [
          {
            required: true,
            message: "请输入所属视频课程id",
            trigger: "blur",
          },
        ],
        value: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类别：免费/付费/会员",
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确",
          },
        ],
        tencentVideoId: [
          {
            required: true,
            message: "请输入腾讯视频id",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "腾讯视频id长度在1到50个字",
          },
        ],
        tencentAppid: [
          {
            required: true,
            message: "请输入腾讯appid",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "腾讯appid长度在1到50个字",
          },
        ],
        enabled: [
          {
            required: true,
            message: "请输入开启 1开启",
            trigger: "change",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 500,
            message: "视频地址长度在1到500个字",
          },
        ],
        playCount: [
          {
            required: true,
            message: "请输入播放次数",
            trigger: "blur",
          },
        ],
        duration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "blur",
          },
        ],
      },
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      editForm2: {
        name: "",
        sort: "",
        tryUse: "-1",
        remark: "",
        startTime: "",
        endTime: "",
        enabled: "1",
      },
      editForm: {
        videoCourseId: "",
        courseId: "",
        name: "",
        sort: "",
        tryUse: "-1",

        price: "",
        tencentVideoId: "",
        tencentAppid: "",
        url: "",
        remark: "",
        enabled: "",
      },
      editFormRules: {
        value: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
        ],
        videoCourseId: [
          {
            required: true,
            message: "请输入所属视频课程id",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属视频课程id格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "名称长度在1到100个字",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "排序格式不正确",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入类别：免费/付费/会员",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确",
          },
        ],
        tencentVideoId: [
          {
            required: true,
            message: "请输入腾讯视频id",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "腾讯视频id长度在1到50个字",
          },
        ],
        tencentAppid: [
          {
            required: true,
            message: "请输入腾讯appid",
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "腾讯appid长度在1到50个字",
          },
        ],
        url: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur",
          },
          {
            min: 1,
            max: 500,
            message: "视频地址长度在1到500个字",
          },
        ],
        enabled: [
          {
            required: true,
            message: "请输入开启 1开启",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "开启 1开启格式不正确",
          },
        ],
        playCount: [
          {
            required: true,
            message: "请输入播放次数",
            trigger: "blur",
          },
        ],
        duration: [
          {
            required: true,
            message: "请输入播放时长",
            trigger: "blur",
          },
        ],
      },
      searchForm: {
        name: null,
      },
      tencentForm: {
        remark: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      importForm: [],
      rowId: "",
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  methods: {
    editBySort(row) {
      this.dialogSortVisible = true;
      this.sortForm = JSON.parse(JSON.stringify(row));
      this.sortForm.tryUse = this.sortForm.tryUse == 1 ? true : false;
    },
    sortComfireBtn() {
      this.sortForm.tryUse = this.sortForm.tryUse ? "1" : "-1";
      this.api.videoInfo.updateTencentVideoId({
        videoInfo: this.sortForm,
      });
      let objParam = {
        id: this.sortForm.subjectVideoRelationId,
        sort: this.sortForm.subjectVideoRelationSort,
        tryDuration: parseInt(this.sortForm.tryDuration),
        tryUse: this.sortForm.tryUse ? "1" : "-1",
      };
      console.log(objParam, "objParam");
      this.api.videoInfo.updateSubjectVideoRelation(objParam).then((res) => {
        this.pageList2();
        this.dialogSortVisible = false;
      });
    },
    getRowKeys(row) {
      return row.index;
    },
    expandSelect(row, expandedRows) {
      var that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.index); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      }
    },
    sortByName(val, index) {
      let apiName;
      let obj = {
        sortState: val,
        type: 1,
      };
      console.log(index);
      if (index == undefined) {
        apiName = "updateVideoInfoSort";
        obj.videoCourseId = this.$route.query.id;
      } else {
        apiName = "updateSubjectVideo";
        obj.id = this.tableData[index].id;
      }
      this.api.videoInfo[apiName](obj).then(() => {
        if (index == undefined) {
          this.pageListLeft();
        } else {
          this.pageList2();
        }
      });
    },
    changeVideoList(ids) {
      this.videoList = ids;
      this.videoList.forEach((e) => {
        this.$set(e, "editBlock", false);
      });

      let objectId = [];
      this.videoList.forEach((item, index) => {
        objectId.push({
          objectId: item.objectId,
          sort: this.tableData[this.subjectVideoIndex].videoInfoList.length + index,
        });
      });
      this.api.videoInfo
        .addSubjectVideoRelation({
          subjectVideoId: this.subjectVideoPid,
          attachmentList: objectId,
        })
        .then((result) => {
          if (result.success) {
            this.selectVideoVisible = false;
            this.selectVideoVisibleBlock = false;
            this.pageList2();
            this.$message.success(result.message);
            this.videoList = [];
          } else {
            this.$message(result.message);
          }
        });
    },
    addGoodsVideo(id, index) {
      console.log(index);
      this.subjectVideoPid = id;
      this.subjectVideoIndex = index;
      this.selectVideoVisibleBlock = true;
      this.selectVideoVisible = true;
    },
    delSubjectVideoRelation(id) {
      this.api.videoInfo
        .delSubjectVideoRelation({
          id: id,
        })
        .then((result) => {
          if (result.success) {
            this.$message.success("解绑成功");
            this.pageList2();
          } else {
            this.$message.error(result.message);
          }
        })

        .catch((error) => {
          console.log(error);
        });
    },
    groupDelete(id) {
      this.$confirm("确定删除该分组吗?", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api.videoInfo
          .delSubjectVideo({
            id: id,
          })
          .then((result) => {
            if (result.success) {
              this.pageList2();
              this.$message.success(result.message);
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    changeType() {
      this.api.videoInfo
        .videoShowWay({
          videoCourseId: this.$route.query.id,
          showState: this.videoTypeValue,
        })
        .then((result) => {
          if (result.success) {
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    editBtn(row) {
      this.form = row;
      this.dialogLevelVisible = true;
    },
    levelSure() {
      if (this.form.id) {
        this.api.videoInfo.updateSubjectVideo(this.form).then((res) => {
          if (res.success) {
            this.dialogLevelVisible = false;
            this.$message.success(res.message);
            this.pageList2();
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.api.videoInfo
          .addSubjectVideo({
            videoCourseId: this.$route.query.id,
            sort: this.form.sort,
            name: this.form.name,
            pid: 0,
          })
          .then((result) => {
            if (result.success) {
              this.dialogLevelVisible = false;
              this.pageList2();
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    handleClick(tab, event) {
      this.pageListLeft();
    },
    pageList2() {
      this.api.videoInfo
        .getSubjectVideoTree({
          videoCourseId: this.$route.query.id,
        })
        .then((result) => {
          if (result.success) {
            result.data.forEach((item, index) => {
              item.index = index;
            });
            this.tableData = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    bindedQuestionList() {
      this.webLoading = true;
      this.api.question
        .pageList(this.bindedQuestionPage)
        .then((result) => {
          this.webLoading = false;
          this.bindedQuestionPage.rows = result.data.records;
          this.bindedQuestionPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.webLoading = true;
      this.searchForm.pageSize = this.questionPage.pageSize;
      this.searchForm.pageNumber = this.questionPage.pageNumber;
      this.searchForm.sortName = this.questionPage.sortName;
      this.searchForm.sortOrder = this.questionPage.sortOrder;

      this.api.question
        .pageList(this.searchForm)
        .then((result) => {
          this.webLoading = false;
          this.questionPage.rows = result.data.records;
          this.questionPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectionChange(val) {
      let arr = [];
      this.multipleSelection = val;
      val.map((e) => arr.push(e.id));
      this.ids = arr;
    },
    innerSizeChange(pageSize) {
      this.questionPage.pageSize = pageSize;
      this.pageList();
    },
    innerCurrentChange(pageNumber) {
      this.questionPage.pageNumber = pageNumber;
      this.pageList();
    },
    innerQuestionSure() {
      this.api.videoInfo
        .bindQuestionBatchVideo({
          videoInfoId: this.videoInfoId,
          questionIdList: this.ids,
        })
        .then((result) => {
          if (result.success) {
            this.innerVisible = false;
            this.bindedQuestionList();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        });
    },
    deleteBindQuestion(id) {
      this.$confirm("确定解绑改题目吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.videoInfo
            .deleteVideoQuestion({
              videoInfoId: this.videoInfoId,
              questionIdList: [id],
            })
            .then((result) => {
              if (result.success) {
                this.bindedQuestionList();
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    bindQuestion(id) {
      this.bindQuestionVisible = true;
      this.videoInfoId = id;
      this.bindedQuestionPage.videoInfoId = id;
      this.bindedQuestionList();
    },

    downloadFileVideo(url, name, scope) {
      window.open(url, "_blank");
    },

    closePopover(id) {
      this.$refs[`popover` + id].doClose();
    },
    updateVideoInfoCourseInfoSort(row) {
      let obj = {
        videoInfoCourseRelationId: row.videoInfoCourseRelationId,
        videoInfoCourseRelationSort: row.videoInfoCourseRelationSort,
      };
      this.api.videoInfo.updateVideoInfoCourseInfoSort(obj).then((result) => {
        if (result.success) {
          this.$refs[`popover` + row.id].doClose();
          this.pageListLeft();
          this.$message.success(result.message);
        } else {
          this.$message.error(result.message);
        }
      });
    },
    selectVideo(item) {
      if (this.loadVideoShow) {
        this.changeVideo(item);
      } else {
        this.inintVideo(item);
      }
    },
    inintVideo(item) {
      this.videoDialog = true;
      this.videoShow = true;
      this.loadVideoShow = true;
      this.$nextTick(function () {
        this.player = TCPlayer("player-container-id", {
          fileID: item.tencentVideoId, // 请传入需要播放的视频 filID（必须）
          appID: item.tencentAppid, // 请传入点播账号的 appID（必须）
          autoplay: true,
        });
      });
    },
    changeVideo(item) {
      this.videoDialog = true;
      this.videoShow = true;
      this.player.loadVideoByID({
        fileID: item.tencentVideoId, // 请传入需要播放的视频 filID（必须）
        appID: item.tencentAppid, // 请传入点播账号的 appID（必须）
        autoplay: true,
      });
    },
    closeDialog() {
      this.player.dispose();
      this.videoShow = false;
    },
    bindExcel() {
      this.api.videoInfo
        .addVideoInfoBatchByExcel({
          videoInfoList: this.importForm,
          videoCourseId: this.id,
        })
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.addFormVisibleExcel = false;
            this.pageListLeft();
            this.importForm = [];
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
          }
        });
    },
    syncTencent() {
      this.syncStatus = true;
      this.api.videoInfo.syncTencent({}).then((result) => {
        this.syncStatus = false;
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.openTencent();
        } else {
          this.$message({
            type: "error",
            message: result.message,
          });
        }
      });
    },
    bindTencent() {
      if (this.addTencentVideo.length > 0) {
        let ids = "";
        let that = this;
        this.addTencentVideo.forEach((res, index) => {
          if (index === that.addTencentVideo.length - 1) {
            ids += res.id;
          } else {
            ids += res.id + ",";
          }
        });
        this.api.videoInfo
          .bindTencent({
            ids: ids,
            videoCourseId: this.id,
          })
          .then((result) => {
            if (result.success) {
              this.$message({
                type: "success",
                message: result.message,
              });
              this.tencentSyncVisible = false;
              this.tencentForm = [];
              this.pageListLeft();
            } else {
              this.$message({
                type: "error",
                message: result.message,
              });
            }
          });
      } else {
        this.$message.error("请选择需要添加的视频！");
      }
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    getVideoInfo(row) {
      this.$router.push({ path: "/editVideoInfo", query: { id: row.id } });
    },
    downloadFile() {
      const url = "./static/file/批量导入视频模板 .xlsx";
      window.open(url);
    },
    addVideoInfo() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let obj = {};
          if (this.name == "直播") {
            obj = this.addForm2;
          } else {
            obj = this.addForm;
          }
          obj.videoCourseId = this.id;
          this.api.videoInfo
            .addVideoInfo(obj)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageListLeft();
                if (this.name == "直播") {
                  this.addFormVisible2 = false;

                  this.addForm2 = {
                    name: "",
                    sort: "",
                    tryUse: "1",
                    remark: "",
                    enabled: "1",
                  };
                } else {
                  this.addFormVisible = false;
                  this.addForm = {
                    videoCourseId: "",
                    name: "",
                    courseId: "",
                    sort: "",
                    tryUse: "1",
                    price: "",
                    tencentVideoId: "",
                    tencentAppid: "",
                    enabled: "1",
                    url: "",
                    remark: "",
                    playCount: "",
                    duration: "",
                  };
                }
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateVideoInfo() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let obj = {};
          if (this.name == "直播") {
            obj = this.editForm2;
          } else {
            obj = this.editForm;
          }
          this.api.videoInfo
            .updateVideoInfo(obj)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                if (this.name == "直播") {
                  this.editFormVisible2 = false;
                } else {
                  this.editFormVisible = false;
                }
                this.pageListLeft();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    subjectChange() {
      this.addForm.courseId = this.addForm.courseId[2];
      this.api.videoCourse
        .getVideoCourseTree({ courseId: this.addForm.courseId })
        .then((result) => {
          this.videoCourseTree = result.data;
        });
      this.addForm.courseId = "";
    },
    subjectEditChange() {
      this.editForm.courseId = this.editForm.courseId[2];
      this.api.videoCourse
        .getVideoCourseTree({ courseId: this.editForm.courseId })
        .then((result) => {
          this.videoCourseTree = result.data;
        });
      this.editForm.courseId = "";
    },
    deleteAddVideoRight(item) {
      this.addVideoRight.forEach((res, index) => {
        if (item.id == res.id) {
          this.addVideoRight.splice(index, 1);
        }
      });
      this.$message.success("移除成功");
    },
    openDio() {
      if (this.name == "直播") {
        this.addFormVisible2 = true;
      } else {
        this.addFormVisible = true;
      }
    },
    // 批量试看
    updateTryUse() {
      if (this.addVideoLeft.length == 0) {
        this.$message({
          message: "请选中至少一条课程!",
          type: "warning",
        });
        return false;
      }
      let temp = [...this.addVideoLeft];
      temp.forEach((e) => {
        this.$set(e, "tryUse", 1);
        this.$set(e, "tryDuration", "999");
      });
      this.api.videoInfo.updateTryUse(temp).then((result) => {
        if (result.success) {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageListLeft();
          this.addVideoLeft = [];
        } else {
          this.$message.error(result.message);
        }
      });
    },

    batchUnbund() {
      let ids = [];
      this.addVideoLeft.forEach((res, index) => {
        ids.push({
          id: res.id,
        });
      });
      if (ids.length) {
        this.$confirm("您确定要进行删除操作吗？", "系统消息", {
          type: "warning",
        })
          .then(() => {
            this.api.videoInfo
              .deleteVideoInfo(ids)
              .then((result) => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message,
                  });
                  this.pageListLeft();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch(() => {});
      } else {
        this.$message({
          message: "请选中至少一条课程!",
          type: "warning",
        });
      }
    },
    goAddVideoInfo() {
      this.$router.push({
        path: "/addVideoInfo",
        query: { id: this.$route.query.id, type: this.$route.query.name },
      });
    },

    openTencent() {
      this.openTencentLoading = true;
      this.tencentForm.pageSize = this.tencentPage.pageSize;
      this.tencentForm.pageNumber = this.tencentPage.pageNumber;
      this.tencentForm.sortName = this.tencentPage.sortName;
      this.tencentForm.sortOrder = this.tencentPage.sortOrder;
      this.tencentSyncVisible = true;
      let that = this;
      this.api.videoInfo
        .getTecent(this.tencentPage)
        .then((result) => {
          this.webLoading = false;
          if (result.success) {
            this.openTencentLoading = false;
            // that.tencentForm = result.data
            that.tencentPage.rows = result.data.records;
            that.tencentPage.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addVideoRightEvent() {
      this.addVideoLeft.forEach((item) => {
        let sty = true;
        this.addVideoRight.forEach((items) => {
          if (item.id == items.id) {
            sty = false;
          }
        });
        if (sty) {
          this.addVideoRight.push(item);
        }
      });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.videoCourseIds = [];
      this.createTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageListLeft();
    },
    timeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    subjectSearchChange() {
      if (this.videoCourseIds.length > 0) {
        this.videoCourseIds.forEach((item) => {
          this.searchForm.videoCourseIds.push(item[2]);
        });
      } else {
        this.searchForm.videoCourseIds = [];
      }
    },
    //左侧list
    pageListLeft() {
      this.webLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.videoCourseId = this.$route.query.id;
      this.searchForm.showState = this.activeName === 'first' ? 0 : 1
      this.api.videoInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.webLoading = false;
          if (result.success) {
            const { data } = result
            if(data.showState){
              data.subjectVideoList.forEach((item, index) => {
                item.index = index;
              });
              this.tableData = data.subjectVideoList;
            }else{
              this.page.rows = data.pageList.records;
              this.page.total = data.pageList.total;
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageListLeft();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageListLeft();
    },
    currentChangeTencent(pageNumber) {
      this.tencentPage.pageNumber = pageNumber;
      this.openTencent();
    },
    sizeChangeTencent(pageSize) {
      this.tencentPage.pageSize = pageSize;
      this.openTencent();
    },
    //选择的video
    selectionChangeLeft(val) {
      this.addVideoLeft = val;
    },
    selectionChangeTencent(val) {
      this.addTencentVideo = val;
    },
    selectionExcel(val) {
      this.addVideoExcel = val;
    },
    datadragEnd(evt) {
      evt.preventDefault();
    },
    deleteVideo(row) {
      this.$confirm("您确定要进行批量解绑操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.videoInfo
            .deleteVideoInfo([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageListLeft();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                }
              }
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  watch: {
    dialogLevelVisible(val) {
      if (!val) {
        this.form = {
          id: undefined,
          name: undefined,
          sort: 0,
        };
      }
    },
    $route: {
      handler() {
        this.rowId = this.$route.query.id;

        if (this.rowId && this.$route.path == "/checkVideo") {
          //编辑时数据详情
          this.pageListLeft();
        }
      },
      deep: true,
    },
    id() {
      this.pageListLeft();
    },
    "addForm2.value"() {
      var date = new Date(this.addForm2.startTime);
      date.setHours(date.getHours() + Number(this.addForm2.value));
      this.addForm2.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    "editForm2.value"() {
      var date = new Date(this.editForm2.startTime);
      date.setHours(date.getHours() + Number(this.editForm2.value));
      this.editForm2.endTime = this.format("yyyy-MM-dd hh:mm:ss", date);
    },
    "addForm2.startTime"() {
      let startTime = new Date(Date.parse(this.addForm2.startTime));
      let endTime = new Date(Date.parse(this.addForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.addForm2.startTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
    "addForm2.endTime"() {
      let startTime = new Date(Date.parse(this.addForm2.startTime));
      let endTime = new Date(Date.parse(this.addForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.addForm2.endTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
    "editForm2.startTime"() {
      let startTime = new Date(Date.parse(this.editForm2.startTime));
      let endTime = new Date(Date.parse(this.editForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.editForm2.startTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
    "editForm2.endTime"() {
      let startTime = new Date(Date.parse(this.editForm2.startTime));
      let endTime = new Date(Date.parse(this.editForm2.endTime));
      //进行比较
      if (startTime > endTime) {
        this.editForm2.endTime = "";
        this.$message.error("开始时间不能大于结束时间");
      }
    },
  },
  mounted() {
    this.getSubjectTreeList();
    this.pageListLeft();
    this.api.videoInfo
      .getVideoShowWay({
        videoCourseId: this.$route.query.id,
      })
      .then((result) => {
        if (result.success) {
          this.videoTypeValue = result.data.showState;
        } else {
          this.$message.error(result.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
<style lang="less" scoped>
.top-type {
  background: #fff;
  padding: 20px 10px;
}
.video-style {
  height: 550px;
  width: 940px;
}
.flex-view {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}

.draggable-tableaaa {
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  height: 436px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }

  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }

    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;

      img {
        display: none !important;
      }

      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;

        img {
          display: none !important;
        }
      }
    }

    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .state {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }

      white-space: nowrap;
    }

    .answer {
      width: 13.3%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .delete {
      width: 13.3%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.two-table {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
  height: 500px;
  width: 100%;

  .left-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .left-right-item {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      border-radius: 50%;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(238, 238, 238, 1);
      font-size: 14px;
      color: #a2aabc;
      margin: 10px;
      cursor: pointer;
    }

    .left-right-item-select {
      width: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      border-radius: 50%;
      background: rgb(64, 158, 255);
      border-width: 1px;
      border-style: solid;
      border-color: rgb(64, 158, 255);
      font-size: 14px;
      color: #ffffff;
      margin: 10px;
      cursor: pointer;
    }
  }
}

p {
  font-size: 14px;
}

.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;

    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;

    .optint-list {
      display: flex;
      flex-direction: column;
    }

    p {
      display: inline;
    }

    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }

  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;

    p {
      display: inline;
    }

    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        display: block;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}

.message {
  display: flex;
  flex-direction: row;

  .state {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .questionTypeName {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }

  .htmltittle {
    white-space: nowrap;
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;

    img {
      display: none !important;
    }

    p {
      font-size: 12px !important;
      font-size: 12px !important;
      margin: 0px !important;
      color: #606266 !important;
      white-space: nowrap !important;

      img {
        display: none !important;
      }
    }
  }
}

.top {
  width: 100%;
  display: flex;
  background: #fff;

  .top-item {
    width: 33.3%;
    margin-left: 10px;

    .item-lable {
      line-height: 30px;
      white-space: nowrap;
      font-size: 12px;
      color: rgb(162, 170, 188);
    }

    .item-value {
      white-space: nowrap;
      font-size: 18px;
      color: rgb(69, 90, 100);
      line-height: 30px;
    }
  }
}

.view-video {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .view-item {
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
    }
  }
}
</style>
<style lang="less" rel="stylesheet/less">
.checkVideo {
  .vjs-big-play-button {
    display: none !important;
  }
}
.operationGroup-flex {
  display: flex;
  .el-input {
    .el-input__inner {
      height: 30px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoCourse/checkVideo.vue